import { Vue } from 'vue-property-decorator';
import get from 'lodash/get';

// filters
import { formatDate } from '@/filters/formatDate';
import { formatDateTime } from '@/filters/formatDateTime';
import { formatDefault } from '@/filters/formatDefault';
import { formatFromNow } from '@/filters/formatFromNow';

import { BooleanTranslationType } from '@/types/types';

const formatBoolean = (val: any, translation: BooleanTranslationType = {}): string => {
  switch (val) {
    case true:
      return translation.true || `shared.inputs.boolean.${val}`;
    case false:
      return translation.false || `shared.inputs.boolean.${val}`;
    default:
      return translation.default || 'shared.inputs.boolean.default';
  }
};

const getFormatDefault = (object: any, path: string, defaultValue: any = '-'): string => {
  const val = get(object, path, defaultValue);
  return val || defaultValue;
};

const formatUpper = (val: any): string => {
  if (!val) {
    return '';
  }

  return val.toString().toUpperCase();
};

/**
 *
 * @param val string or number
 * @return formated number depending on locale
 */
const formatNumber = (val: any, defaultValue: any = '0'): string => {
  return (val) ? val.toLocaleString() : defaultValue.toLocaleString();
};

/**
 *
 * @param snake string
 * @return cameled string
 */
const replaceUnderscore = (snake: string): string | null => {
  if (snake) {
    const camel = snake.match(/[A-Za-z]*/g) || [];
    return camel.join(' ');
  }
  return null;
};

Vue.filter('formatBoolean', formatBoolean);
Vue.filter('formatDate', formatDate);
Vue.filter('formatDateTime', formatDateTime);
Vue.filter('formatDefault', formatDefault);
Vue.filter('formatFromNow', formatFromNow);
Vue.filter('formatNumber', formatNumber);
Vue.filter('formatUpper', formatUpper);
Vue.filter('getFormatDefault', getFormatDefault);
Vue.filter('replaceUnderscore', replaceUnderscore);

export {
  formatBoolean,
  formatDate,
  formatDateTime,
  formatDefault,
  formatFromNow,
  formatNumber,
  formatUpper,
  getFormatDefault,
  replaceUnderscore
};
